var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolygonZkevm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 380",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -377.32,
    y1: 1035.25,
    x2: -46.57,
    y2: 1189.12,
    gradientTransform: "matrix(1, 0, 0, -1, 404, 1293.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a726c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#803bdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b3fe4"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "380") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 400,
    height: 380
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M356.56,150.91V239a49.65,49.65,0,0,1-24.68,43L224.73,343.68a49.75,49.75,0,0,1-49.56,0l-107-61.79A49.13,49.13,0,0,1,50.7,265a50.26,50.26,0,0,1-7.36-23.16,15.63,15.63,0,0,1,2.27-9.09,15.92,15.92,0,0,1,7.15-6.17l277.39-119a23.63,23.63,0,0,0-10.93-13.42L212.29,32.31a24.64,24.64,0,0,0-24.46,0l-107,61.8a24.55,24.55,0,0,0-9,9,24,24,0,0,0-3.25,12.23v77.3l-25,10.67v-88A50.07,50.07,0,0,1,68.33,72.38l107-61.78a49.8,49.8,0,0,1,49.55,0l107,61.78a49.67,49.67,0,0,1,24.78,40,15.6,15.6,0,0,1-2.27,9.08,15.84,15.84,0,0,1-7.14,6.17L70,246.67a23.8,23.8,0,0,0,11,13.41l106.89,61.78a24.62,24.62,0,0,0,24.45,0l107-61.78a24.55,24.55,0,0,0,9-9,23.94,23.94,0,0,0,3.25-12.22V161.63Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonZkevm);
export default __webpack_public_path__ + "static/media/polygon-zkevm.e21da99705ecfd5c18236edd845b916f.svg";
export { ForwardRef as ReactComponent };